module.exports = __webpack_public_path__ + "static/media/TN-Women-Bags.dfd62346.svg";